// import { NgModule,
//          ErrorHandler } from '@angular/core'

//          // ,
//          // ɵ_sanitizeStyle } from '@angular/core'

// // import { BrowserModule,
// //          DomSanitizer } from '@angular/platform-browser'

// // import { BrowserAnimationsModule } from '@angular/platform-browser/animations'

import { Event, Router, Scroll } from '@angular/router'

// // App Root
// import { AppComponent } from './app.component'

// // Eager Loaded Modules
import { CoreModule } from './_core/core.module'
import { SharedModule } from './_shared/shared.module'
// import { AuthModule } from './auth/auth.module'

// import { CloudinaryModule } from '@cloudinary/ng';
// import { LottieModule } from 'ngx-lottie';



// // import { PopupModule } from './popup/popup.module'

// // // Routing Module
import { AppRoutingModule } from './app-routing.module'

import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core'
// import { BrowserModule } from '@angular/platform-browser'
// import { FormsModule } from "@angular/forms"
import { AppComponent } from './app.component'

import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field'

import { NgxContentfulRichTextModule } from 'ngx-contentful-rich-text';

import { CommonModule, APP_BASE_HREF, PlatformLocation, provideCloudinaryLoader } from '@angular/common'


// CORE
// import { LoginComponent } from './auth/login/login.component'
// import { CookieConsentPageComponent } from './auth/cookie-consent-page/cookie-consent-page.component'
import { TermsPageComponent } from './terms-page/terms-page.component'
import { PrivacyPageComponent } from './privacy-page/privacy-page.component'
import { ThankYouPageComponent } from './thank-you-page/thank-you-page.component'
import { ContactPageComponent } from './contact-page/contact-page.component'


// CUSTOM: LCP

import { TeamComponent } from './team/team.component';
import { AboutComponent } from './about/about.component';
import { ContactComponent } from './contact/contact.component';
// import { FooterComponent } from './footer/footer.component';
// import { HeaderComponent } from './header/header.component';
import { HomepageComponent } from './homepage/homepage.component';
import { HomepageV1Component } from './homepage-v1/homepage-v1.component';
import { ProjectComponent } from './project/project.component';
import { ProjectsComponent } from './projects/projects.component';
import { RepoComponent } from './repo/repo.component';
import { RichTextComponent } from './rich-text/rich-text.component';
import { RichTextInternalLinkComponent } from './rich-text/rich-text.component';

// import { DeleteOrderPopupComponent } from  './delete-order-popup/delete-order-popup.component'
// import { DeleteServicePopupComponent } from './delete-service-popup/delete-service-popup.component'
import { DeleteUserPopupComponent } from './delete-user-popup/delete-user-popup.component'


// CUSTOM: OAK PARK
// import { HomeComponent } from './home/home.component'
// import { RequestQuotePageComponent } from './request-quote-page/request-quote-page.component'
// import { PaymentSubmittedPageComponent } from './payment-submitted-page/payment-submitted-page.component'
// import { OrderSubmittedPageComponent } from './order-submitted-page/order-submitted-page.component'
// import { OrderInvoicePageComponent } from './order-invoice-page/order-invoice-page.component'
// import { ConfirmOrderPopupComponent } from './confirm-order-popup/confirm-order-popup.component'


import { ViewportScroller } from '@angular/common';
import { filter } from 'rxjs';


import { environment } from './_core'
import { GoogleInitOptions, GoogleLoginProvider, SocialAuthServiceConfig } from '@abacritt/angularx-social-login'
import { ServicesComponent } from './services/services.component'
import { ServiceComponent } from './service/service.component'

const GOOGLE_CLIENT_ID = environment.google_client_id;
// const GOOGLE_CLIENT_SECRET = environment.google_client_secret;
const GOOGLE_LOGIN_OPTIONS: GoogleInitOptions = {
  oneTapEnabled: false, // default is true
}



// import { HomeComponent } from './home/home.component'; // implements the home route


// const GOOGLE_CLIENT_ID = environment.google_client_id;
// // const GOOGLE_CLIENT_SECRET = environment.google_client_secret;
// const GOOGLE_LOGIN_OPTIONS: GoogleInitOptions = {
//   oneTapEnabled: false, // default is true
// }

@NgModule({
  imports: [
    CommonModule,
    CoreModule,
    SharedModule,
    // AuthModule,
    // HomeModule,
    AppRoutingModule,
    // FontAwesomeModule,
    // CloudinaryModule,
    // LottieModule,
    NgxContentfulRichTextModule
  ],
  declarations: [
    AppComponent,
    ContactPageComponent,
    // DeleteOrderPopupComponent,
    // DeleteServicePopupComponent,
    DeleteUserPopupComponent,
    PrivacyPageComponent,
    TeamComponent,
    TermsPageComponent,
    ThankYouPageComponent,
    AboutComponent,
    ContactComponent,

    // RequestQuotePageComponent,
    // PaymentSubmittedPageComponent,
    // OrderSubmittedPageComponent,
    // OrderInvoicePageComponent,
    // ConfirmOrderPopupComponent,
    // FooterComponent,
    // HeaderComponent,

    HomepageComponent,
    HomepageV1Component,
    ProjectComponent,
    ProjectsComponent,
    RepoComponent,
    RichTextComponent,
    RichTextInternalLinkComponent,
    ServicesComponent,
    ServiceComponent
  ],
  providers: [
    {
      provide: "SocialAuthServiceConfig",
      useValue: {
        autoLogin: false,
        prompt: false,
        providers: [
          { id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(
              GOOGLE_CLIENT_ID,
              GOOGLE_LOGIN_OPTIONS
            )},
        ]
      } as SocialAuthServiceConfig
    },
    // FIXES overlapping form errors and hints
    {
        provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
        useValue: {
          subscriptSizing: 'dynamic'
      }
    },

    { 
      provide: APP_BASE_HREF,
      useFactory: (s: PlatformLocation) => s.getBaseHrefFromDOM(),
      deps: [PlatformLocation]
    },

    // provideCloudinaryLoader('https://res.cloudinary.com/lcp_wedding_gown_/image/upload'),
  
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
  bootstrap: [
    AppComponent
  ]
})

// export class AppModule {
//   constructor(
//     // private readonly router: Router,
//   ) {
//     // router.events.subscribe(console.log)
//   }
// }



export class AppModule {

  prevPath: any

  constructor(router: Router, viewportScroller: ViewportScroller) {
    router.events.pipe(
      filter((e: Event): e is Scroll => e instanceof Scroll)
    ).subscribe(e => {

      // CUSTOM PAGE LOAD SCROLL-TOP
      // scroll to top if main path changed; skip scroll if base route unchanged
      const newPath = location.pathname // router.url.split('?')[0]
      if (newPath == this.prevPath) return
      this.prevPath = newPath
      viewportScroller.scrollToPosition([0, 0]);
      // console.log('AppModule - router.url', router.url.split('?')[0])

    });
  }
}